import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { Menu, Tab } from 'semantic-ui-react';
import Helmet from 'react-helmet';
import FacebookPreview from './FacebookPreview';
import LinkedinPreview from './LinkedinPreview';
import TwitterPreview from './TwitterPreview';
import InstagramPreview from './InstagramPreview';
import GMBPreview from './GMBPreview';
import xLogo from '../../assets/x-logo.svg';
import gmbLogo from '../../assets/google-my-business-logo.svg';
import instagramLogo from '../../assets/instagram-logo.svg';
import facebookLogo from '../../assets/facebook-logo.svg';
import linkedinLogo from '../../assets/linkedin-icon.svg';
import * as styles from './PostPlatformPreview.scss';
var PostPlatformPreview = (_dec = connect(function (state) {
  var _state$organization, _state$organization$s;

  var orgId = state.organization.current.id;
  return {
    socialAccounts: (_state$organization = state.organization) === null || _state$organization === void 0 ? void 0 : (_state$organization$s = _state$organization.selectedOrgDetails[orgId]) === null || _state$organization$s === void 0 ? void 0 : _state$organization$s.SocialAccounts,
    organization: state.organization.current
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PostPlatformPreview, _Component);

  var _super = _createSuper(PostPlatformPreview);

  function PostPlatformPreview(props) {
    var _this;

    _classCallCheck(this, PostPlatformPreview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      igImageSlideIndex: 0
    });

    _defineProperty(_assertThisInitialized(_this), "getPlatformPreview", function (platform) {
      //DraftApproval.jsx is a logged out page and doesn't have access to props.socialAccounts
      // special case for linkedin
      var socialAccount;

      if (_this.props.passedInSocialAccounts) {
        socialAccount = _this.props.passedInSocialAccounts.find(function (sa) {
          return sa.platform.split(' ').join('').toLowerCase() === platform;
        });
      } else {
        socialAccount = _this.props.socialAccounts.find(function (sa) {
          return sa.platform.split(' ')[0].toLowerCase() === platform;
        });
      }

      switch (platform) {
        case 'google':
        case 'googlemybusiness':
          return {
            menuItem: /*#__PURE__*/React.createElement(Menu.Item, {
              key: "gmb"
            }, /*#__PURE__*/React.createElement("img", {
              src: gmbLogo,
              style: {
                height: 24
              }
            })),
            render: function render() {
              return /*#__PURE__*/React.createElement(Tab.Pane, null, /*#__PURE__*/React.createElement(GMBPreview, {
                account: socialAccount,
                images: _this.props.images,
                link: _this.props.link,
                message: _this.props.messages['googleMybusiness'] || _this.props.messages['Google my business'] || _this.props.messages['google'] || _this.props.messages['global'],
                postDate: _this.props.postDate,
                postType: _this.props.postType,
                videos: _this.props.videos
              }));
            }
          };

        case 'facebook':
        case 'facebookpage':
          return {
            menuItem: /*#__PURE__*/React.createElement(Menu.Item, {
              key: "fb"
            }, /*#__PURE__*/React.createElement("img", {
              src: facebookLogo,
              style: {
                height: 24
              }
            })),
            render: function render() {
              return /*#__PURE__*/React.createElement(Tab.Pane, null, /*#__PURE__*/React.createElement(FacebookPreview, {
                account: socialAccount,
                groupPost: _this.props.groupPost,
                link: _this.props.link,
                linkCaption: _this.props.linkCaption,
                linkTitle: _this.props.linkTitle,
                images: _this.props.images,
                message: _this.props.messages['facebook'] || _this.props.messages['Facebook page'] || _this.props.messages['global'],
                postDate: _this.props.postDate,
                postType: _this.props.postType,
                videos: _this.props.videos
              }));
            }
          };

        case 'twitter':
          return {
            menuItem: /*#__PURE__*/React.createElement(Menu.Item, {
              key: "twitter"
            }, /*#__PURE__*/React.createElement("img", {
              src: xLogo,
              style: {
                height: 24
              }
            })),
            render: function render() {
              return /*#__PURE__*/React.createElement(Tab.Pane, null, /*#__PURE__*/React.createElement(TwitterPreview, {
                account: socialAccount,
                link: _this.props.link,
                linkDescription: _this.props.linkDescription,
                linkTitle: _this.props.linkTitle,
                images: _this.props.images,
                message: _this.props.messages['twitter'] || _this.props.messages['Twitter'] || _this.props.messages['global'],
                postDate: _this.props.postDate,
                videos: _this.props.videos
              }));
            }
          };

        case 'instagram':
          return {
            menuItem: /*#__PURE__*/React.createElement(Menu.Item, {
              key: "instagram"
            }, /*#__PURE__*/React.createElement("img", {
              src: instagramLogo,
              style: {
                height: 24
              }
            })),
            render: function render() {
              return /*#__PURE__*/React.createElement(Tab.Pane, null, /*#__PURE__*/React.createElement(InstagramPreview, {
                account: socialAccount,
                igImageSlideIndex: _this.state.igImageSlideIndex,
                images: _this.props.images,
                message: _this.props.messages['instagram'] || _this.props.messages['Instagram'] || _this.props.messages['global'],
                setImageSlideIndex: function setImageSlideIndex(newIndex) {
                  return _this.setState({
                    igImageSlideIndex: newIndex
                  });
                },
                videos: _this.props.videos
              }));
            }
          };

        case 'linkedin':
        case 'linkedinprofile':
        case 'linkedincompany':
          return {
            menuItem: /*#__PURE__*/React.createElement(Menu.Item, {
              key: "tab_".concat(platform),
              style: {
                position: 'relative'
              }
            }, /*#__PURE__*/React.createElement("img", {
              src: linkedinLogo,
              style: {
                height: 24
              }
            }), /*#__PURE__*/React.createElement("div", {
              style: {
                bottom: 6,
                fontSize: 8,
                position: 'absolute'
              }
            }, platform === 'linkedinprofile' ? 'Profile' : platform === 'linkedincompany' ? 'Company' : '')),
            render: function render() {
              return /*#__PURE__*/React.createElement(Tab.Pane, null, /*#__PURE__*/React.createElement(LinkedinPreview, {
                account: socialAccount,
                images: _this.props.images,
                isCompany: platform === 'linkedincompany',
                link: _this.props.link,
                linkTitle: _this.props.linkTitle,
                message: _this.props.messages['linkedin'] || _this.props.messages['LinkedIn company'] || _this.props.messages['global'],
                postDate: _this.props.postDate,
                postType: _this.props.postType,
                videos: _this.props.videos
              }));
            }
          };
      }
    });

    return _this;
  }

  _createClass(PostPlatformPreview, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (newProps.images && this.props.images) {
        if (newProps.images.length < this.props.images.length) {
          var val = newProps.images.length > 0 ? newProps.images.length - 1 : 0;

          if (this.state.igImageSlideIndex > newProps.images.length - 1) {
            this.setState({
              igImageSlideIndex: val
            });
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      //TODO error visibility
      var _ref = this.props.postOrgId ? this.props.postOrgId : this.props,
          organization = _ref.organization;

      var features = _toConsumableArray((organization === null || organization === void 0 ? void 0 : organization.FeatureAvailabilities) || []); //DraftApproval.jsx is a logged out page and doesn't have access to props.organization


      var hasGmb = true;

      var accountPanes = _toConsumableArray(this.props.platforms).filter(function (p) {
        return p !== 'google' || p === 'google' && hasGmb;
      }).sort();

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
        href: "https://fonts.googleapis.com/css?family=Roboto&display=swap",
        rel: "stylesheet"
      })), /*#__PURE__*/React.createElement(Tab, {
        panes: accountPanes.map(function (platform) {
          return _this2.getPlatformPreview(platform);
        })
      }));
    }
  }]);

  return PostPlatformPreview;
}(Component), _defineProperty(_class2, "defaultProps", {
  groupPost: false,
  platforms: ['facebook', 'google', 'instagram', 'linkedinprofile', 'linkedincompany', 'twitter'],
  messages: [],
  images: [],
  link: null,
  linkTitle: '',
  linkDescription: '',
  linkCaption: '',
  postDate: moment(),
  style: {}
}), _temp)) || _class);
export { PostPlatformPreview as default };